import { useEffect, useState } from "react";
import { NavLink ,useNavigate } from "react-router-dom";
import { getNotifications } from "../../services/notification-service";
import NotificationAccordion from "../notifications/notification-accordion";


function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  const userData = JSON.parse(localStorage.getItem("userdata") || "{}");
  const userLoginId = userData?.id;

  useEffect(() => {
    (async () => {
      try {
        const res = await getNotifications(userLoginId);
        setNotifications(res?.notifications || []);
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const totalPages = Math.ceil(notifications.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const displayedItems = notifications.slice(startIndex, startIndex + itemsPerPage);

  return (
    <>
      <div className="page-titles bg-white px-6">
        <div className="flex items-center">
          <div className="mr-4 kr-page-back-btn">
            <button
              type="button"
              className="btn-primary rounded flex items-center justify-center w-8"
              onClick={() => {
               
                if (window.history.length > 2) {
                  navigate(-1);
                } else {
                  navigate("/master");
                }
              }}
            >
              <svg width={18} className="svg-white" x="0px" y="0px" viewBox="0 0 700 700">
                <g>
                  <path
                    d="M82.9,331.2l148.3,148.3c7.6,7.6,18.6,10.6,29,7.8c10.4-2.8,18.5-10.9,21.2-21.2c2.8-10.4-0.2-21.4-7.8-29l-97.6-96.9
      h304.7c15.8,0,31,6.3,42.1,17.5c11.2,11.2,17.5,26.3,17.5,42.1v79c0,10.6,5.7,20.5,14.9,25.8c9.2,5.3,20.6,5.3,29.8,0
      c9.2-5.3,14.9-15.2,14.9-25.8v-79c0-31.6-12.6-61.9-34.9-84.3c-22.4-22.4-52.7-34.9-84.3-34.9H176.1l97.6-97.6
      c7.6-7.6,10.6-18.6,7.8-29c-2.8-10.4-10.9-18.5-21.2-21.2c-10.4-2.8-21.4,0.2-29,7.8L82.9,288.7c-5.7,5.6-8.9,13.3-8.9,21.2
      S77.2,325.6,82.9,331.2L82.9,331.2z"
                  ></path>
                </g>
              </svg>
            </button>
          </div>
          <div>
            <h2 className="font-bold color-dark text-[14px] mb-0">Notifications</h2>
            <span className="text-gray-400 text-[12px]">
              Approve or reject pending e-waste requests
            </span>
          </div>
        </div>
      </div>

      <div className="pageBody-inner p-6">
        <div className="kr-block">
          <div className="card !border-none">
            <div className="card-inner p-0">
              {loading ? (
                <div className="w-100 flex justify-center items-center py-6 bg-light">
                  <div className="kr-pageLoader">
                    <span className="loader"></span>
                  </div>
                </div>
              ) : displayedItems.length === 0 ? (
                <p className="py-6 text-center text-sm text-slate-500">No notifications yet.</p>
              ) : (
                <>
                  <div className="p-4">
                    <NotificationAccordion items={displayedItems} />
                  </div>

                  <div className="kr-block pt-3 pb-3 font-size-12px color-gray border-top px-3">
                    <nav className="w-full position:relative m-0">
                      <ul className="list-none ml-0 mb-0 pagination">
                        <li
                          className={`inline-block pagination-prev cursor-pointer ${currentPage === 1 ? "disabled" : ""
                            }`}
                          onClick={() => currentPage > 1 && setCurrentPage((p) => p - 1)}
                        >
                          <span>Previous</span>
                        </li>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                          <li
                            key={p}
                            className={`inline-block cursor-pointer hover:backdrop-brightness-90 ${currentPage === p ? "current" : ""
                              }`}
                            onClick={() => setCurrentPage(p)}
                          >
                            <span>{p}</span>
                          </li>
                        ))}
                        <li
                          className={`inline-block pagination-next cursor-pointer ${currentPage === totalPages ? "disabled" : ""
                            }`}
                          onClick={() => currentPage < totalPages && setCurrentPage((p) => p + 1)}
                        >
                          <span>Next</span>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Notifications;